import { Tab, TabProps } from "@mui/material";
import React from "react";
import TabLabel from "../tab-label/TabLabel";

export type TabWithCountProps = {
    label: string;
    count?: number;
    countDisabled?: boolean;
} & TabProps;

export default function TabWithCount({ label, count, countDisabled, ...rest }: TabWithCountProps) {
    return (
        <Tab label={<TabLabel label={label} count={count} disabled={countDisabled} />} {...rest} />
    );
}
